<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid">
        <div class="row">
          <div class="text-start my-2 col">
            <label class="px-2"> وضعیت </label>
            <select class="form-control" v-model="verified" @change="getComments">
              <option value="all">همه</option>
              <option value="1">منتشر شده</option>
              <option value="0">در انتظار انتشار</option>
            </select>
          </div>
          <div class="text-start my-2 col">
            <label class="px-2"> محصول </label>
            <Select2
              class="mt-2"
              :options="productList"
              :settings="{ placeholder: 'انتخاب محصول' }"
              v-model="productId"
            />
          </div>
        </div>
        <div class="table-responsive">
          <span v-show="!comments" >
            <i class="fas fa-spinner fa-spin fs-1 mt-3"></i>
          </span>
          <table class="caption-top table table-hover table-striped">
            <caption>
              {{
                this.$route.meta.title
              }}
            </caption>
            <thead class="table-dark">
              <tr>
                <th scope="col">ردیف</th>
                <th scope="col">فرستنده</th>
                <th scope="col">متن</th>
                <th scope="col">محصول</th>
                <th scope="col">تاریخ</th>
                <th scope="col">#</th>
                <th scope="col">#</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in comments" :key="item.id">
                <th style="width: 3%" scope="row">
                  {{ index + 1 }}
                </th>
                <td>
                  <span v-if="item.verified">
                    <i class="fas fa-check text-success"></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-window-close text-danger"></i>
                  </span>
                  {{ item.user.fist_name }} {{ item.user.last_name }}
                </td>
                <td class="text-start">
                  {{ item.comment }}
                </td>
                <td style="width: 3%">
                  {{ item.product.name }}
                </td>
                <td>
                  {{ jmoment(item.created_at).format("jYYYY/jMM/jDD HH:mm:ss") }}
                </td>
                <td>
                  <div v-if="item.verified">
                    <button
                      class="btn btn-danger btn-sm"
                      @click="editComment(item.id, '0', $event)"
                    >
                      عدم انتشار
                    </button>
                  </div>
                  <div v-else>
                    <button
                      class="btn btn-success btn-sm"
                      @click="editComment(item.id, '1', $event)"
                    >
                      منتشر کردن
                    </button>
                  </div>
                </td>
                <td>
                  <a class="btn btn-sm btn-danger" @click="deleteItem(item.id)">
                    <i class="fas fa-trash"></i>
                    حذف
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="lastPage > 1"
          class="d-flex justify-content-center bd-highlight mb-3"
        >
          <span
            v-if="showPreviusSpin"
            class="fas fa-spinner fa-spin mt-3"
          ></span>
          <a
            :disabled="currentPage > 1"
            :class="
              'btn btn-primary btn-sm m-1 ' +
              (currentPage > 1 ? '' : 'disabled')
            "
            @click="previusPage()"
          >
            قبلی
          </a>
          <select class="m-1 p-1" @change="changePage($event)">
            <option
              v-for="index in this.lastPage"
              :key="index"
              :selected="index == this.currentPage"
            >
              {{ index }}
            </option>
          </select>
          <a
            :disabled="currentPage != lastPage"
            :class="
              'btn btn-primary btn-sm m-1 ' +
              (currentPage != lastPage ? '' : 'disabled')
            "
            @click="nextPage()"
          >
            بعدی
          </a>
          <span v-if="showNextSpin" class="fas fa-spinner fa-spin mt-3"></span>
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
  <!-- /#wrapper -->
</template>

<script>
import TheSidemenu from "../components/TheSidemenu";
import TheTopmenu from "../components/TheTopmenu";
import ArefApi from "../libs/api.js";
import utils from "../libs/utils.js";
import jmoment from "moment-jalaali";
import Select2 from "vue3-select2-component";

export default {
  name: "ListComments",
  created: function () {
    this.arefApi = new ArefApi(this);
    this.utils = new utils();
    this.jmoment = jmoment;
    this.getComments();
    this.getproductList();
  },
  components: {
    TheSidemenu,
    TheTopmenu,
    Select2,
  },
  data() {
    return {
      comments: null,
      currentPage: this.$route.params.page ? this.$route.params.page : 1,
      lastPage: null,
      showPreviusSpin: false,
      showNextSpin: false,
      verified: "all",
      productId: "",
      productList:null
    };
  },
  methods: {
    getComments() {
      this.comments= null;
      const obj = {
        productId: this.productId == -1 ? '':this.productId ,
        page: this.currentPage,
        verified: this.verified,
      };
      this.arefApi
        .getAllComments(obj)
        .then((resp) => {
          this.comments = resp.data;
          this.currentPage = resp.meta.current_page;
          this.lastPage = resp.meta.last_page;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    async getproductList() {
      let out = [{id:'-1',text:'همه'}];
      try {
        const res = await this.arefApi.getProductsIndex(1, true);
        for (let i in res.data) {
          out.push({
            id: res.data[i].id,
            text: res.data[i].name,
          });
        }
      } catch (e) {
        console.log(e);
      }
      this.productList = out;
    },
    nextPage: async function () {
      this.showNextSpin = true;
      this.currentPage++;
      this.$router.push({
        name: "ListComments",
        params: { page: this.currentPage },
      });
      await this.getComments(this.currentPage);
      this.showNextSpin = false;
    },
    previusPage: async function () {
      this.showPreviusSpin = true;
      this.currentPage--;
      this.$router.push({
        name: "ListComments",
        params: { page: this.currentPage },
      });
      await this.getComments(this.currentPage);
      this.showPreviusSpin = false;
    },
    changePage: function (event) {
      this.currentPage = event.target.value;
      this.$router.push({
        name: "ListComments",
        params: { page: this.currentPage },
      });
      this.getComments(event.target.value);
    },
    deleteItem: function (commentId) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .deleteComment(commentId)
              .then(() => {
                this.$swal
                  .fire({
                    title: ``,
                    text: `حذف با موفقیت انجام شد`,
                    icon: "success",
                  })
                  .then(() => {
                    this.getComments(this.currentPage);
                  });
              })
              .catch((err) => {
                this.$swal.fire({
                  title: `خطا`,
                  text: err.data.error,
                  icon: "error",
                });
              });
          }
        });
    },
    editComment(commentId, verified, e) {
      e.target.disabled = true;
      const obj = {
        id: commentId,
        verified: verified,
      };
      this.arefApi
        .editComment(obj)
        .then(() => {
          this.getComments();
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          e.target.disabled = false;
        });
    },
  },
  watch:{
    productId: function(){
      this.getComments();
    }
  }
};
</script>
<style>
.select2-container--default {
  min-width: 200px;
  max-width: 300px;
}
</style>